import { render } from "./XIconSolidListTree.vue?vue&type=template&id=79cbc372"
import script from "./XIconSolidListTree.vue?vue&type=script&lang=js"
export * from "./XIconSolidListTree.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidListTree.vue"]])

export default __exports__